<template>
    <div id='alert' v-if="alertShow">
        <div class="box" @click.self="off">
            <div class="content">
                <h2 class="h">資訊</h2>
                <div class="slideBox">
                    <p>危險貨物清單分類及如何處理貨物</p>
                    <p>危險品泛指一切在空運時能對健康、安全、財產或環境構成危險的物品或物質。國際民航組
                        織(CAO)把這些危險品分為以下9類</p>
                    <div class="class">
                        <el-row type="flex">
                            <el-col :span="4">
                                <span>第1類</span>
                            </el-col :span="18">
                            <el-col>
                                <span>爆炸品( Explosives)</span>
                            </el-col>
                        </el-row>
                        <el-row type="flex">
                            <el-col :span="4">
                                <span>第2類</span>
                            </el-col :span="18">
                            <el-col>
                                <span>氣體( Gases)</span>
                            </el-col>
                        </el-row>
                        <el-row type="flex">
                            <el-col :span="4">
                                <span>第3類</span>
                            </el-col :span="18">
                            <el-col>
                                <span>易燃液體( Flammable Liquids</span>
                            </el-col>
                        </el-row>
                        <el-row type="flex">
                            <el-col :span="4">
                                <span>第4類</span>
                            </el-col :span="18">
                            <el-col>
                                <span>易燃固體( Flammable Solids);易於自燃的物質( Substances Liable to
                                    Spontaneous Combustion);遇水釋放易燃氣體的物質( Substances which
                                    incontact with Water. Emit Flammable Gases</span>
                            </el-col>
                        </el-row>
                        <el-row type="flex">
                            <el-col :span="4">
                                <span>第5類</span>
                            </el-col :span="18">
                            <el-col>
                                <span>氧化性物質( Oxidizing Substances)及有機過氧化物( Organic Peroxides</span>
                            </el-col>
                        </el-row>
                        <el-row type="flex">
                            <el-col :span="4">
                                <span>第6類</span>
                            </el-col :span="18">
                            <el-col>
                                <span>毒性物質( Toxic)及威染性物質( Infectious Substances</span>
                            </el-col>
                        </el-row>
                        <el-row type="flex">
                            <el-col :span="4">
                                <span>第7類</span>
                            </el-col :span="18">
                            <el-col>
                                <span>放射性物料( Radioactive Materials</span>
                            </el-col>
                        </el-row>
                        <el-row type="flex">
                            <el-col :span="4">
                                <span>第8類</span>
                            </el-col :span="18">
                            <el-col>
                                <span>腐蝕性物質( Corrosive Substances)</span>
                            </el-col>
                        </el-row>
                        <el-row type="flex">
                            <el-col :span="4">
                                <span>第9類</span>
                            </el-col :span="18">
                            <el-col>
                                <span>其他危險物質和物品( Miscellaneous dangerous substances and articles</span>
                            </el-col>
                        </el-row>
                        <el-row>
                            <span>(有關妥善處理危險貨物/電池運輸的資訊υ請訪問以下網站)</span>
                        </el-row>
                    </div>
                    <div class="links">
                        <div class="item">
                            <div class="h">國際民用航空組織(ICAO)</div>
                            <li>
                                <a href="https://www.icao.int/safety/dangerousgoods/pages/background.aspx">https://www.icao.int/safety/dangerousgoods/pages/background.aspx</a>
                            </li>
                        </div>
                        <div class="item">
                            <div class="h">國際航空運輸協會(IATA)</div>
                            <li>
                                <a href="https://www.iata.org/publications/dgr/pages/index.aspx">https://www.iata.org/publications/dgr/pages/index.aspx</a>
                            </li>
                        </div>
                        <div class="item">
                            <div class="h">國際海事組纖(IMO)</div>
                            <li>
                                <a href="http://www.imo.org/en/publications/imdgcode/pages/default.aspx">http://www.imo.org/en/publications/imdgcode/pages/default.aspx</a>
                            </li>
                        </div>
                        <div class="item">
                            <div class="h">中國民用航空局(CAAC)</div>
                            <li>
                                <a href="http://www.caac.gov.cn/website/old/b1/b6/201310/t20131016_58946.html">http://www.caac.gov.cn/website/old/b1/b6/201310/t20131016_58946.html</a>
                            </li>
                            <li>
                                <a href="http://www.caacgov.cn/website/old/b1/b6/201310/p020140805605586785481.pdf">http://www.caacgov.cn/website/old/b1/b6/201310/p020140805605586785481.pdf</a>
                            </li>
                        </div>
                        <div class="item">
                            <div class="h">香港民航處(CAD)</div>
                            <li>
                                <a href="https://www.cad.gov.hk/english/dgdetail.htm">https://www.cad.gov.hk/english/dgdetail.htm</a>
                            </li>
                        </div>
                    </div>
                    <div class="tips">
                        <span>注意:對於任何其他敏威的商品(例如:戰路商品)建議在發貨前對原產地或目的地國家
                            進行檢查。</span>
                    </div>
                </div>
                <div class="btns">
                    <div class="on">
                        <optionsButton title="知道了" :callback="on"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import optionsButton from '@/components/optionButton'
export default {
    name:'Alert',
    props:["callback","alertShow"],
    components:{
        optionsButton
    },
    data(){
        return {
        }
    },
    methods: {
        // 监听用户点击是
        on(){
            if(typeof this.callback == 'function'){
                this.callback(true)
            }
        },
    },
}
</script>

<style lang="less">
    @keyframes show {
        0%{
            opacity: 0;
        }
        100%{
            opacity: 1;
        }
    }
    #alert{
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        text-align: center;
        background-color: #656565;
        z-index: 9999;
        .box{
            display: flex;
            height: 100%;
            justify-content: center;
            align-items: center;
            animation: show .5s;
            .content{
                width: 600px;
                height: 600px;
                border-radius: 20px;
                background-color: #fff;
                text-align: center;
                padding: 30px;
                .slideBox{
                    width: 100%;
                    height: 350px;
                    overflow:scroll;
                    padding:30px;
                    .class{
                        line-height: 30px;
                        .el-row{
                            justify-content: space-between;
                            .el-col{
                                text-align: left;
                            }
                        }
                    }
                    .links{
                       .item{
                            .h{
                                font-size: 17px;
                                text-align:left;
                                font-weight:600;
                            }
                           li{
                               white-space: nowrap;
                               text-align: left;
                               margin-left: 5px;
                               color: @colorMain;
                               a{
                                color: @colorMain;
                               }
                           }
                       }
                    }
                    .tips{
                        text-align: left;
                        color: #e75252;
                        margin-top: 30px;
                        line-height: 20px;
                        font-weight: 580;
                    }
                }
                .h{
                    
                    text-align:center;
                    color: @colorMain;
                    font-size:30px;
                    margin-top:30px;
                    padding-bottom:20px;
                }
                p{
                    font-size: 17px;
                    font-weight: 580;
                    text-align:left;
                    margin: 10px 0;
                    font-size: 16px;
                    font-weight: 580;
                    line-height: 25px;
                }
                .btns{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-top: 50px;
                }
            }
        }
    }
</style>